import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'

const circle7124 = keyframes`
  0% {
    top: 60px;
    height: 5px;
    border-radius: 50px 50px 25px 25px;
    transform: scaleX(1.7);
  }
  40% {
    height: 20px;
    border-radius: 50%;
    transform: scaleX(1);
  }
  100% {
    top: 0%;
  }
`

const shadow046 = keyframes`
  0% {
    transform: scaleX(1.5);
  }
  40% {
    transform: scaleX(1);
    opacity: .7;
  }
  100% {
    transform: scaleX(.2);
    opacity: .4;
  }
`

const LoadingBox = styled(Box)(({ theme }) => ({
  width: '200px',
  height: '60px',
  margin: 'auto',
  position: 'relative',
  zIndex: 1,
  '& .circle-loading': {
    width: '20px',
    height: '20px',
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: '#FF9900',
    left: '15%',
    transformOrigin: '50%',
    animation: `${circle7124} .5s alternate infinite ease`
  },
  '& .circle-loading:nth-child(2)': {
    left: '45%',
    animationDelay: '.2s'
  },
  '& .circle-loading:nth-child(3)': {
    left: 'auto',
    right: '15%',
    animationDelay: '.3s'
  },
  '& .shadow-loading': {
    width: '20px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    position: 'absolute',
    top: '62px',
    transformOrigin: '50%',
    zIndex: -1,
    left: '15%',
    filter: 'blur(1px)',
    animation: `${shadow046} .5s alternate infinite ease`
  },
  '.shadow-loading:nth-child(4)': {
    left: '45%',
    animationDelay: '.2s'
  },

  '.shadow-loading:nth-child(5)': {
    left: 'auto',
    right: '15%',
    animationDelay: '.3s'
  }
}))

function AmazonLoading() {
  return (
    <LoadingBox>
      <div class='circle-loading'></div>
      <div class='circle-loading'></div>
      <div class='circle-loading'></div>
      <div class='shadow-loading'></div>
      <div class='shadow-loading'></div>
      <div class='shadow-loading'></div>
    </LoadingBox>
  )
}

export default AmazonLoading
